import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
// ngrx store
import { Store } from '@ngrx/store';
// services
import { DataStorageService } from '../../../shared/services/data-storage.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';
import { FormsModule } from '@angular/forms';
import { NotificationsComponent } from '@shared/components/notifications/notifications.component';
import { VerifyEmailComponent } from 'app/login/components/verify-email/verify-email.component';
import { LanguageSelectorComponent } from '@shared/components/language-selector/language-selector.component';
import { RESET_USER_STATE } from '@shared/reducers/user.reducer';
declare var ga: any;

@Component({
  selector: 'app-verify-email-section',
  standalone: true,
  imports: [CommonModule, FormsModule, NotificationsComponent, VerifyEmailComponent, LanguageSelectorComponent],
  templateUrl: './verify-email-section.component.html',
  styleUrls: ['./verify-email-section.component.scss'],
  providers: [DataStorageService]
})
export class VerifyEmailSectionComponent implements OnInit {

  constructor(
    private _dataStorageService: DataStorageService,
    private _appStore: Store<AppState>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {
      ga('set', 'page', '/login');
      ga('send', 'pageview');

      this._dataStorageService.removeCookie('dataID');
      this._dataStorageService.removeCookie('dataT');
      this._dataStorageService.removeCookie('portrE');
    }
    this._appStore.dispatch(RESET_USER_STATE());
  }

}
